import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { runner } from '../../docs-routes'

const RunnerRunSelectedStepsDescription = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      Filter test steps for this run. All test steps are included by default. This filter will reset after each run.
    </Color>
    <LinkToDocusaurus path={runner}>
      Learn more in the DAI documentation
    </LinkToDocusaurus>
  </Paragraph>

export default RunnerRunSelectedStepsDescription
